export enum PromoBannerReferenceType {
  General = 0,
  Category = 1,
  BlogPost = 2,
  Product = 3
}

export enum PromoBannerPosition {
  Blog = 'promo-left',
  Product = 'promo-right'
}

export interface PromoBannerGroup {
  id: string;
  name: string;
  description: string | null;
  banner_count: number;
  sort_order: number | null;
  is_active: boolean;
  pageType: number;
  pageLocationType: number;
}

export interface PromoBanner {
  id: string;
  slug: string;
  image: string | null;
  link: string | null;
  position: string | null;
  sort_order: number | null;
  add_info: string | null;
  banner_group_id: string | null;
  reference_type: PromoBannerReferenceType;
  reference_id: string | null;
  category_id?: string | null;
  title: string;
  description: string;
  is_active: boolean;
  start_date: string | null;
  end_date: string | null;
  product?: PromoBannerProduct | null;
}

export interface PromoBannerApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export interface PromoBannerCollection<T> {
  collection: T[];
  total: number;
  pagesize: number;
  pageIndex: number;
}

export interface PromoBannerSaveRequest {
  slug: string;
  link: string | null;
  position: PromoBannerPosition;
  sort_order: number;
  add_info: string;
  banner_group_id: string;
  reference_type: PromoBannerReferenceType;
  reference_id: string | null;
  title: string;
  description: string;
  is_active: boolean;
  start_date: string | null;
  end_date: string | null;
}

export interface PromoBannerPageData {
  group: PromoBannerGroup | null;
  blogBanner: PromoBanner | null;
  productBanner: PromoBanner | null;
}

export interface PromoBlogBannerFormData {
  groupId: string;
  banner: PromoBanner | null;
}

export interface PromoBlogBannerFormResult {
  saved: boolean;
}

export interface PromoBannerProduct {
  id: string;
  name: string;
  slug?: string | null;
  product_code?: string | null;
  sapatco_code?: string | null;
  sku?: string | null;
  default_image?: string | null;
  product_category_id?: string | null;
  is_hidden?: boolean;
}

export interface PromoProductBannerFormData {
  groupId: string;
  banner: PromoBanner | null;
}

export interface PromoProductBannerFormResult {
  saved: boolean;
}
